import React from 'react';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './Ajouter.module.scss';
import { checkMot } from '../../../ressources/functionJS/checkMot';

/**
 * Composant réutilisable pour les champs de formulaire
 * @param {Object} props - Propriétés du composant
 * @param {string} props.name - Nom du champ (attribut name)
 * @param {string} props.label - Libellé du champ
 * @param {string} props.placeholder - Texte d'exemple
 * @param {string} props.value - Valeur actuelle du champ
 * @param {Function} props.onChange - Gestionnaire de changement
 * @param {boolean} props.required - Si le champ est obligatoire
 * @param {string} props.type - Type de champ (text, select, etc.)
 * @param {Array} props.options - Options pour les champs select
 * @param {string} props.additionalClass - Classes CSS supplémentaires
 * @param {JSX.Element} props.validationMessage - Message de validation
 * @returns {JSX.Element} Champ de formulaire
 */
const FormField = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  required = false,
  type = 'text',
  options = [],
  additionalClass = '',
  validationMessage = null,
}) => {
  return (
    <div className={s.form_group}>
      <div className={[s.form_row, s.align_items_center].join(' ')}>
        <div className={s.col_12}>
          <label className={s.card_header}>{checkMot(label)}</label>

          {type === 'text' && (
            <input
              type="text"
              className={[
                s.form_control,
                s.mb_2,
                name === 'project_name' ? styles.fore : '',
                additionalClass,
              ].join(' ')}
              placeholder={placeholder}
              name={name}
              value={value}
              required={required}
              onChange={onChange}
            />
          )}

          {type === 'select' && (
            <select
              onChange={onChange}
              name={name}
              defaultValue={value}
              className={[s.custom_select, s.mr_sm_2, additionalClass].join(
                ' '
              )}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}

          {validationMessage}
        </div>
      </div>
    </div>
  );
};

export default FormField;
